import '../App.css'
import { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown'
import apiHelper from '../helpers/apiHelper';
import txImg from '../assets/images/Region F_Map_Texas.png'
import { markdownComponents } from '../components/MarkdownComponents';

export default function Home() {
    const [homepageData, setHomepageData] = useState(null);
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        const loadData = async () => {
            try {
                setLoading(true);
                const api = new apiHelper();
                const data = await api.GetHomepageContent();
                console.log(data);
                setHomepageData(data);
            } catch (error) {
                console.error('Error loading homepage content:', error);
            } finally {
                setLoading(false);
            }
        };
        
        
        loadData();
    }, []);

    const getPageData = (data) => {
        try {
            return JSON.parse(data.pageData);
        } catch (error) {
            console.error('Error parsing pageData:', error);
            return { title: 'Error', content: 'Unable to load content' };
        }
    }

    return (
        <div>
            <main role="main" className="flex-shrink-0 min-vh-100">
                <div className='container mt-4'>
                    <div className='row'>
                        <div className='col-lg-7' id="home-content">
                            {loading ? (
                                <div className='text-center py-5'>
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className='mt-2 mb-0'>Loading content...</p>
                                </div>
                            ) : homepageData ? (
                                <div className='markdown-content'>
                                    <ReactMarkdown components={markdownComponents}>{getPageData(homepageData).content}</ReactMarkdown>
                                </div>
                            ) : (
                                <div className='text-center py-5'>
                                    <h4 className='text-muted'>Unable to load homepage content</h4>
                                </div>
                            )}
                        </div>
                        <div className='col-lg-5'>
                            <img src={txImg} alt="Region F Map of Texas" objectFit='cover' className='w-100' />
                        </div>
                    </div>
                </div>
            </main >
        </div >
    )
}